import { render, staticRenderFns } from "./PermissionsMaster.vue?vue&type=template&id=f8d45148&scoped=true&"
import script from "./PermissionsMaster.vue?vue&type=script&lang=ts&"
export * from "./PermissionsMaster.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsMaster.vue?vue&type=style&index=0&id=f8d45148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d45148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VRow})
